// site-message-bar.component.ts

import {
  Component,
  inject,
} from '@angular/core';

import {
  trigger,
  transition,
  style,
  animate,
} from '@angular/animations';

import { CommonModule } from '@angular/common';
import {
  MessageBarService,
  SiteMessage,
} from '../../services/message-bar.service';
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'msh-site-message-bar',
  standalone: true,
  imports: [CommonModule, MatIcon],
  animations: [
    trigger('messageAnimation', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(-12px)',
        }),
        animate(
          '200ms ease-out',
          style({
            opacity: 1,
            transform: 'translateY(0)',
          })
        ),
      ]),
      transition(':leave', [
        animate(
          '200ms ease-in',
          style({
            opacity: 0,
            transform: 'translateY(-12px)',
          })
        ),
      ]),
    ]),
  ],
  template: `
    <div
      class="fixed top-0 left-0 right-0 z-50 flex flex-col gap-2 p-3 pointer-events-none"
    >
      @for (msg of service.messages(); track msg.id) {
        <div
          @messageAnimation
          class="pointer-events-auto rounded-xl shadow-lg border overflow-hidden"
          [class]="getContainerClass(msg)"
        >
          <div class="flex items-start gap-4 p-4">

            <div class="flex-1">
              @if (msg.title) {
                <div class="font-semibold text-sm mb-1">
                  {{ msg.title }}
                </div>
              }

              <div class="text-sm">
                {{ msg.message }}
              </div>
            </div>

            <div class="flex items-center gap-2 shrink-0">

              @if (msg.ctaLabel && msg.ctaAction) {
                <button
                  class="px-3 py-1.5 rounded-lg bg-white/20 hover:bg-white/30 transition text-sm font-medium"
                  (click)="msg.ctaAction()"
                >
                  {{ msg.ctaLabel }}
                </button>
              }

              @if (msg.dismissible !== false) {
                <mat-icon
                  class="w-8 h-8 rounded-lg hover:bg-black/10 transition flex items-center justify-center"
                  (click)="dismiss(msg.id)"
                >close</mat-icon>
              }

            </div>

          </div>
        </div>
      }
    </div>
  `,
})
export class SiteMessageBarComponent {
  service = inject(MessageBarService);

  dismiss(id: string) {
    this.service.dismiss(id);
  }

  getContainerClass(msg: SiteMessage): string {
    switch (msg.type) {
      case 'success':
        return 'bg-green-100 border-green-300 text-green-900';

      case 'warning':
        return 'bg-yellow-100 border-yellow-300 text-yellow-900';

      case 'error':
        return 'bg-red-100 border-red-300 text-red-900';

      default:
        return 'bg-copy border-back/50 text-back';
    }
  }
}